<template>
    <div>
        <b-modal
            v-model="localShow"
            @change="updateShow"
            centered
            size="sm"
            hide-header
            hide-footer
            body-class=""
        >
            <div class="d-flex justify-content-center align-items-center" style="min-height: 120px;">
                <save-success
                    :message="message"
                    :icon-font-scale="iconFontScale"
                ></save-success>
            </div>
        </b-modal>
    </div>
</template>

<script>
//import { errorHandling } from '../../js/custom-vue-mixins';

export default {
    name: 'SuccessModal',
    components: {},
    mixins: [
        //errorHandling,
    ],
    props: {
        message: {
            type: String,
            default: 'Saved'
        },
        show: {  // toggle this to show/hide the modal
            type: Boolean,
            default: false,
        },
        iconFontScale: {
            type: String,
            default: '3',
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            localShow: this.show,  // the local toggle for showing/hiding the modal
        }
    },
    watch: {
        show: function(newValue) {
            this.localShow = newValue;
        },
    },
    mounted: function() {
        
    },
    methods: {
        // allow using $refs and methods to open/close also
        open: function() {
            this.localShow = true;
        },
        close: function() {
            this.localShow = false;
        },
        toggle: function() {
            this.localShow = !this.localShow;
        },
        /// PRIVATE
        updateShow: function(show) {
            // need this to make prop.sync work
            this.$emit('update:show', show);
        }
    }
}
</script>

<style>

</style>